<script>
import { CdrText, CdrLink } from '@rei/cedar';
import metrics from '../../mixins/metrics';
import hoursMixin from '../../mixins/storeCommons';

export default {
  name: 'StoreAtThisLocationComponent',
  components: {
    CdrText,
    CdrLink,
  },
  mixins: [metrics, hoursMixin],
  props: {
    pageAtThisLocationData: {
      type: Object,
      required: true,
    },
    storeData: {
      type: Object,
      required: true,
    },
  },
};
</script>

<template>
  <article class="this-store">
    <cdr-text
      data-ui="store-hero-title"
      class="this-store__title"
      tag="h2"
    >
      {{ pageAtThisLocationData.title }}
    </cdr-text>
    <ul
      class="this-store__container"
      gutter="small"
    >
      <li
        v-for="(service, index) in pageAtThisLocationData.storeServiceItems"
        :key="index"
        class="this-store__item"
      >
        <cdr-link
          v-if="service.url"
          :id="`service_url-${service.key}`"
          :key="`service_url-${service.key}`"
          :href="service.url"
          @click="metricsClick(service.name)"
        >
          {{ service.name }}
        </cdr-link>
        <cdr-text
          v-else
        >
          {{ service.name }}
        </cdr-text>
      </li>
    </ul>
  </article>
</template>